module.exports = __webpack_public_path__ + "static/media/telicon-2.2.0.f95a93c9.svg";